module.exports = __webpack_public_path__ + "static/media/rating.e3907fc3.png";